import { Modal, ModalBody, ModalFooter, ModalHeader } from "@lmig/lmds-react-modal";
import { Heading } from "@lmig/lmds-react-typography";
import RichText from "../Shared/Tiles/RichText";
import { Button } from "@lmig/lmds-react-button";

interface ProductGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  modalHeader?: string;
  modalBody?: string;
}

export interface ProductGuideModalObject {
  ErrorMessage: string;
  ModalHeader: string;
  ModalBody: string;
}

export async function GetProductGuideModal(): Promise<ProductGuideModalObject> {
  let result: ProductGuideModalObject = { ModalHeader: '', ModalBody: '', ErrorMessage: 'GetProductGuideModal call did not finish' };
  try {
    const res = await fetch('/api/sitecore/NowNavigationAsync/GetProductGuideModal');
    const contentType = res.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      const result = await res.json() as ProductGuideModalObject;
      return result;
    } else {
      console.error('GetProductGuideModal');
      console.error(res.text());
    }
  } catch (err: any) {
    console.error('GetProductGuideModal');
    console.error(err.message);
  }
  return result;
}

export const ProductGuideModal = ({ isOpen, onClose, onConfirm, modalHeader, modalBody }: ProductGuideModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose} size="medium" spacing="large" className='product-guide-modal'>
    <ModalHeader className='product-guide-modal-header'>
      <Heading type="h3-light">
        {modalHeader && modalHeader}
      </Heading>
    </ModalHeader>
    <ModalBody className="product-guide-modal-body">
      {modalBody && <RichText content={modalBody}/>}
    </ModalBody>
    <ModalFooter className='product-guide-modal-footer'>
      <Button variant="primary" onClick={onConfirm}>
        Open Product Guide
      </Button>
    </ModalFooter>
  </Modal>
);